<template>
    <div class="container table-data">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="公司名称" prop="commercial_id" v-if="commercials.length > 0">
                <el-select v-model="queryForm.commercial_id" placeholder="全部" v-if="commercials.length > 1" @change="getShopList()">
                    <el-option v-for="item in commercials" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
                <el-input type="text" :value="commercials[0].name" disabled v-if="commercials.length == 1"></el-input>
            </el-form-item>
            <el-form-item label="店铺名称" prop="shop_id" v-if="shops.length > 0">
                <!--<el-select v-model="queryForm.shop_id" placeholder="请选择店铺">-->
                    <!--<el-option v-for="item in shops" :label="item.name" :value="item.id" :key="item.id"></el-option>-->
                <!--</el-select>-->
                <el-select
                        v-model="queryForm.shop_id"
                        filterable
                        remote
                        clearable
                        :remote-method="remoteShopMethod"
                        placeholder="请输入店铺">
                    <el-option
                            v-for="item in shopList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开始日期" prop="startDate1">
                <el-date-picker
                  v-model="queryForm.startDate1"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
                <!--<el-date-picker-->
                        <!--v-model="queryForm.dateRange"-->
                        <!--type="daterange"-->
                        <!--align="right"-->
                        <!--unlink-panels-->
                        <!--range-separator="至"-->
                        <!--placeholder="请选择日期"-->
                        <!--:picker-options="pickerOptions">-->
                <!--</el-date-picker>-->
            </el-form-item>
            <el-form-item label="结束日期" prop="endDate1">
              <el-date-picker
                v-model="queryForm.endDate1"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-row class="pb20">
            <!--<div>-->
                <!--<el-button type="primary" @click="exportExcel()">导出</el-button>-->
                <!--<form name="downForm" method="get"></form>-->
            <!--</div>-->
            <!--<export-excel :params="exportParams" :action="$apiUrl.commercialOrderInfo" :target="'oc'" :field="field" :filename="fileName" :fieldname="fieldName" style="display: inline-block"></export-excel>-->
          <el-button size="mini" type="primary" @click="exportExcel()">导出excel</el-button>
          <el-button size="mini" type="primary" @click="handleDataSummary" style="display: inline-block;margin-left: 20px">数据求和</el-button>
          <div v-if="showSummaryInfo" style="display: inline-block;margin-left: 10px;color:red">
                <span style="margin-right: 10px;">求和周期:{{summaryInfo.summaryPeriod}}</span>
                <span style="margin-right: 10px;">总退订单数:{{summaryInfo.totalRefundNum}}</span>
                <span style="margin-right: 10px;">总营业额:{{summaryInfo.totalPayCallback}}</span>
                <span style="margin-right: 10px;">总退款额:{{summaryInfo.totalRefundAmount}}</span>
                <span style="margin-right: 10px;">总结算额:{{summaryInfo.totalSettleAmount}}</span>
            </div>
          <el-button size="mini" type="primary" @click="shopDataChange()" style="float: right;">店铺数据调整</el-button>
          <div>
            <h3 style="display: inline-block; margin-top: 10px;">各食堂在线销售汇总</h3>
            <span style="color: red;">实时数据报表仅支持查看近30天的数据</span>
          </div>

        </el-row>
        <!--table-->
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%"
          :span-method="objectSpanMethod">
          <el-table-column
            v-for="(item, index) in tableColumn"
            :prop="item.id"
            :label="item.name"
            :show-overflow-tooltip="true"
            :key="index"
            :width="item.width">
          </el-table-column>
      </el-table>

      <!--pagination-->
        <!--<el-pagination-->
                <!--@size-change="handleSizeChange"-->
                <!--@current-change="handleCurrentChange"-->
                <!--:current-page="queryForm.pageNo"-->
                <!--:page-sizes="pageSizes"-->
                <!--:page-size="queryForm.pageSize"-->
                <!--layout="total, sizes, prev, pager, next"-->
                <!--:total="total">-->
        <!--</el-pagination>-->
      <el-dialog title="店铺顺序调整" :visible.sync="dialogVisible" center width="70%">
        <el-table
          :data="shopData"
          max-height="500"
          border>
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            prop="shopName"
            label="店铺名称"
            :show-overflow-tooltip="true"
            width="">
          </el-table-column>
          <el-table-column
            prop=""
            width="200px"
            label="操作">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.$index === 0"
                @click.native.prevent="scope.$index === 0 ? '' :  move(scope.row,scope.$index,1)"
                type="text"
                size="small">
                上移
              </el-button>
              <el-button
                :disabled="scope.$index === shopData.length - 1"
                @click.native.prevent="scope.$index === shopData.length - 1 ? '' : move(scope.row,scope.$index,2)"
                type="text"
                size="small">
                下移
              </el-button>
            </template>

          </el-table-column>
        </el-table>

      </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment'
    import ExportExcel from "../../../components/exportExcel2.vue"
    import * as _ from 'lodash';
    const transformObj = {
      'incomeAmount': '营业额（元）',
      'refundAmount': '退款额（元）',
      'settleAmount': '结算额（元）'
    };
    const turnoverObj = {
      'incomeAmount': 'shopIncomeAmount',
      'refundAmount': 'shopRefundAmount',
      'settleAmount': 'shopSettleAmount'
    };
    export default {
        components: {ExportExcel},
        data() {
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    // pageSize: 10,
                    // pageNo: 1,
                    startDate: '',
                    endDate: '',
                    startDate1: '',
                    endDate1: '',
                    // dateRange: [],
                    commercial_id: '',
                    //commercial_idList: '',
                    shop_id: '',
                    //shop_idList: ''
                    for_report: true
                },

                tableData: [],//表格数据
                tableColumn:[],
                total: 0,//总数
                pageSizes: [10,20,30,40,50],//自定义分页条数
                multipleSelection: [],//table选中项
                loading: true,//表格是否显示加载效果

//                 pickerOptions: {
//                     shortcuts: [
//                         {
//                             text: '今日',
//                             onClick(picker) {
// //                                const end = new Date();
//                                 const start = new Date();
// //                                start.setTime(start.getTime() - 3600 * 1000 * 24);
//                                 picker.$emit('pick', [start, start]);
//                             }
//                         }, {
//                             text: '昨日',
//                             onClick(picker) {
// //                                const end = new Date();
//                                 const start = new Date();
//                                 start.setTime(start.getTime() - 3600 * 1000 * 24);
//                                 picker.$emit('pick', [start, start]);
//                             }
//                         }, {
//                         text: '最近7天',
//                         onClick(picker) {
//                             const end = new Date();
//                             const start = new Date();
//                             start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
//                             picker.$emit('pick', [start, end]);
//                         }
//                     }, {
//                         text: '最近30天',
//                         onClick(picker) {
//                             const end = new Date();
//                             const start = new Date();
//                             start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
//                             picker.$emit('pick', [start, end]);
//                         }
//                     }]
//                 },

                commercials: JSON.parse(localStorage.getItem('commercials')),
                shops: JSON.parse(localStorage.getItem('shops')),
                shopList: [],

                //导出
                // exportParams: {},
                // fileName: '销售分析表',
                // fieldName: ['公司名称','店铺名称','日期','营业额（元）','订单数','客单价','配送费','满意度'],
                // field: ['commercialName','supplierName','date','payCallback','orderNumber','perCustomerTransaction','deliveryFee','degreeOfSatisfaction'],
                showSummaryInfo: false,
                summaryInfo: {},//汇总信息
                spanArr: [],
                pos: 0,
                spanArr2: [],
                pos2: 0,
                dialogVisible: false,
                shopData: [],
                commerArr: []
            }
        },
        created(){
            var day = new Date();
            day.setTime(day.getTime()-24*60*60*1000);
            this.queryForm.startDate1 = this.queryForm.endDate1 = day;
            this.fetchData();
            this.commerArr = [];
            this.commercials.forEach(item=>{
              this.commerArr.push(item.id)
            });
        },
        methods: {
            //店铺数据调整
            shopDataChange(){
              this.dialogVisible = true
            },
            move(val,index,num){
              let params={
                shop_id: val.shopId,
                firstSort: 0,
                middleSort: 0,
                endSort: 0
              };
              if(num === 1 && index != 1){//上移
                params.firstSort = this.shopData[index-2].sort;
                params.endSort = this.shopData[index-1].sort;
              }
              if(num === 1 && index == 1){//上移 第二个
                params.firstSort = 0;
                params.endSort = this.shopData[index-1].sort;
              }
              if(num === 2 && index !=this.shopData.length-2){//下移
                params.firstSort = this.shopData[index+1].sort;
                params.endSort = this.shopData[index+2].sort;
              }
              if(num === 2 && index ==this.shopData.length-2){//下移 倒数第二个
                params.firstSort = this.shopData[index+1].sort;
                params.endSort = 0;
              }
              params.middleSort = this.shopData[index].sort;
              this.$api.post(this.$apiUrl.shopMove,params,(res)=>{
                this.$message.success(res.message);
                this.fetchData();
              },(res)=>{
                this.$message.warning(res.message);
              })
            },
            //导出excel
            exportExcel(){
              let monthDiff = moment(this.queryForm.endDate1).diff(moment(this.queryForm.startDate1), 'months')
              if(monthDiff>2){
                this.$message.warning('实时数据表仅支持导出近3个月的数据');
                return
              }
              let ids = this.queryForm.commercial_id ? this.queryForm.commercial_id: this.commerArr.join(',')
              let hostStr = window.location.host;
              let host = hostStr.replace('e','oc');
              let url = location.protocol +'//'+ host + '/' + this.$apiUrl.commercialExport + '?commercialIds=' + ids + '&schoolIds=' + localStorage.getItem('schoolId') +  '&shopIds=' + this.queryForm.shop_id + '&startDate=' + moment(this.queryForm.startDate1).format('YYYYMMDD') + '&endDate=' + moment(this.queryForm.endDate1).format('YYYYMMDD');
              window.open(url);
            },
            //合并列
            objectSpanMethod({ row, column, rowIndex, columnIndex }){
              if (columnIndex === 0 || columnIndex === this.tableColumn.length-1) {
                const _row = this.spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                  };
              }
              if (columnIndex === 1 || columnIndex === this.tableColumn.length-2 || columnIndex === this.tableColumn.length-3) {
                const _row = this.spanArr2[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                  rowspan: _row,
                  colspan: _col
                };
              }
            },
            getSpanArr(data){
              this.spanArr = [];
              this.spanArr2 = [];
              for(var i=0;i<data.length;i++){
                  if(i===0){
                    this.spanArr.push(1)
                    this.pos = 0
                    this.spanArr2.push(1)
                    this.pos2 = 0
                  } else {
                    if (data[i].commercialId === data[i - 1].commercialId) {
                      // 如果useName相等就累加，并且push 0
                      this.spanArr[this.pos] += 1
                      this.spanArr.push(0)
                    } else {
                      // 不相等push 1
                      this.spanArr.push(1)
                      this.pos = i
                    }
                    if (data[i].shopId === data[i - 1].shopId) {
                      // 如果useName相等就累加，并且push 0
                      this.spanArr2[this.pos2] += 1
                      this.spanArr2.push(0)
                    } else {
                      // 不相等push 1
                      this.spanArr2.push(1)
                      this.pos2 = i
                    }
                  }

                }

            },
            //抓取列表数据
            fetchData() {
                let params = {...this.queryForm};
                params.startDate = moment(params.startDate1).format('YYYYMMDD');
                params.endDate = moment(params.endDate1).format('YYYYMMDD');
                let dayDiff = moment(params.endDate1).diff(moment(params.startDate1), 'days')
                if(dayDiff>30){
                  this.$message.warning('只能查询30天之内的数据！如需更多数据，请导出excel进行查看');
                  return
                }
                // this.exportParams = {...params};
                // this.exportParams.pageNo = 1;
                // this.exportParams.pageSize = 99999;
                this.loading = true;
                this.$apiJava.get(this.$apiUrl.commercialOrder,params,(res)=>{
                    // this.total = res.data.total || 0;
                    // this.tableData = res.data.commercialList || [];
                    let shopDailyList = _.get(res, 'data.commercialList.0.shopList.0.shopDailyList', []);
                    shopDailyList = shopDailyList.map((item) => ({
                        id: item.day,
                        name: item.day,
                        width: '',
                    }));
                    this.tableColumn = [
                        { id: 'commercialName', name: '公司名称', width: '120' },
                        { id: 'shopName', name: '店铺名称', width: '100' },
                        { id: 'turnover', name: '', width: '100' },
                        ...shopDailyList,
                        { id: 'incomeAmount', name: '店铺合计', width: '90' },
                        { id: 'orderNum', name: '订单数（单）', width: '100' },
                        { id: 'shopPerAmount', name: '客单价（元）', width: '100' },
                        { id: 'totalAmount', name: '合计（元）', width: '100' }
                    ];

                  this.tableData = [];
                  this.shopData = [];
                  if(res.data.commercialList && res.data.commercialList.length>0){
                    // this.func(res.data.commercialList,transformObj,turnoverObj)
                    res.data.commercialList.forEach((firItem)=>{
                      firItem.shopList.forEach((secItem) => {
                        this.shopData.push({
                          shopId: secItem.shopId,
                          shopName: secItem.shopName,
                          sort: secItem.sort
                        });
                        _.each(transformObj, (thrItem, key) => {
                          let shopArr = {};
                          secItem.shopDailyList.forEach((shopItem) => {
                            shopArr = { ...shopArr, [shopItem.day]: shopItem[key] };
                          });
                          this.tableData.push(
                            {
                              commercialId: firItem.commercialId,
                              shopId: secItem.shopId,
                              commercialName: firItem.commercialName,
                              shopName: secItem.shopName,
                              turnover: thrItem,
                              ...shopArr,
                              incomeAmount: secItem[turnoverObj[key]],
                              orderNum: secItem.orderNum,
                              shopPerAmount: secItem.shopPerAmount,
                              totalAmount: firItem.totalAmount
                            }
                          )
                        })
                      });
                    });
                    this.getSpanArr(_.cloneDeep(this.tableData));
                  }
                  this.showSummaryInfo = false;
                  this.loading = false;
                },(res)=>{
                    this.$message.warning(res.message);
                    this.loading = false;
                    this.tableData = [];
                },'oc')
            },
            func(data,transformObj,turnoverObj){
              // let i = 0;
              // let timer = setInterval(()=>{
              //   data[i].shopList.forEach((secItem) => {
              //     this.shopData.push({
              //       shopId: secItem.shopId,
              //       shopName: secItem.shopName,
              //       sort: secItem.sort
              //     });
              //     _.each(transformObj, (thrItem, key) => {
              //       let shopArr = {};
              //       secItem.shopDailyList.forEach((shopItem) => {
              //         shopArr = { ...shopArr, [shopItem.day]: shopItem[key] };
              //       });
              //       this.tableData.push(
              //         {
              //           commercialId: data[i].commercialId,
              //           shopId: secItem.shopId,
              //           commercialName: data[i].commercialName,
              //           shopName: secItem.shopName,
              //           turnover: thrItem,
              //           ...shopArr,
              //           incomeAmount: secItem[turnoverObj[key]],
              //           orderNum: secItem.orderNum,
              //           shopPerAmount: secItem.shopPerAmount,
              //           totalAmount: data[i].totalAmount
              //         }
              //       )
              //     })
              //   });
              //   this.getSpanArr(_.cloneDeep(this.tableData));
              //   i++;
              //   if(i > data.length - 1){
              //     clearInterval(timer)
              //   }
              // },1000);

            },
            handleDataSummary() {
                if(this.queryForm.startDate1){
                    let params = {
                        commercial_id: this.queryForm.commercial_id,
                        shop_id: this.queryForm.shop_id,
                        startDate: moment(this.queryForm.startDate1).format('YYYYMMDD'),
                        endDate: moment(this.queryForm.endDate1).format('YYYYMMDD'),
                        pageSize: 999999,
                        pageNo: 1,
                        for_report: true
                    }
                    this.$apiJava.post(this.$apiUrl.dataSummary,params,(res)=>{
                        this.summaryInfo = res.data
                        this.summaryInfo.summaryPeriod = params.startDate +'- '+ params.endDate
                        this.showSummaryInfo = true
                    },(res)=>{
                        this.$message.warning(res.message);
                        this.summaryInfo = {};
                    },'oc')
                }else{
                    this.$message.warning('请选择时间')
                }

            },
            remoteShopMethod(query){
                if (query !== '') {
                    this.shopList = [];
                    var arr = [];
                    let len = this.shops.length;
                    var reg = new RegExp(query);
                    for(var i=0;i<len;i++){
                        //如果字符串中不包含目标字符会返回-1
                        if(this.shops[i].name.match(reg)){
                            this.shopList.push(this.shops[i]);
                        }
                    }
                } else {
                    this.shopList = [];
                }
            },
            getShopList() {
                this.queryForm.shop_id = '';
                this.shopList = [];
                this.$api.get(this.$apiUrl.getShopList,{commercial_id: this.queryForm.commercial_id,page: 1,pageSize: 50},(res)=>{
                    if(res.data){
                        for(let k in res.data){
                            this.shopList.push({id:k,name:res.data[k]});
                        }
                    }else {
                        this.shopList = [];
                    }
                })
            },
            //表单重置 item上需要添加prop属性
            resetForm(formName) {
                this.$refs[formName].resetFields();
//                this.queryForm.dateRange = [];
            },
            //切换每页显示条数操作
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.fetchData();
            },
            //切换页码操作
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.fetchData();
            }
        }
    }
</script>
<style lang="scss">
  .table-data .el-table{
    -webkit-text-size-adjust: none;
  }
</style>



// WEBPACK FOOTER //
// order.vue?20a0ae11